/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Devices_Cant_DeleteInputs */

const es_user_profile_devices_cant_delete = /** @type {(inputs: User_Profile_Devices_Cant_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No puede borrar su dispositivo actual`)
};

const en_user_profile_devices_cant_delete = /** @type {(inputs: User_Profile_Devices_Cant_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You cannot delete your current device`)
};

/**
* | output |
* | --- |
* | "You cannot delete your current device" |
*
* @param {User_Profile_Devices_Cant_DeleteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_devices_cant_delete = /** @type {((inputs?: User_Profile_Devices_Cant_DeleteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Devices_Cant_DeleteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_devices_cant_delete(inputs)
	return en_user_profile_devices_cant_delete(inputs)
});
export { user_profile_devices_cant_delete as "user.profile.devices.cant_delete" }